import React from 'react';
import { useNavigate } from 'react-router-dom';
import './index.css';

const Kill = () => {
  const navigate = useNavigate();

  const homepage = () => {
    navigate('/Login');
  }

  return (
    <React.Fragment>
      <div className="kill-container">
        <div className="kill-content">
          <h2 className="kill-title"><b>Unauthorized access !</b></h2>
          <h3 className="kill-subtitle">or Site is under maintenance</h3>
          <div className="mt-5 mb-3">
            <button className="btn-login-theme" onClick={homepage}>LOGIN 🠆</button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Kill;
